import { IAction, ECampaignStatus } from "store/store.interface";
import {
  ADD_BULK_BUNDLE_JOB_TO_THE_LIST,
  BULK_BUNDLE_SET_JOBS,
  BULK_BUNDLE_UPDATE_JOB_STATUS,
  BULK_BUNDLE_CLEAR_JOB_LIST,
  BULK_BUNDLE_UPDATE_PAGE_NUMBER,
} from "../store.types";

export interface IBulkBundleJob {
  createdAt: Date;
  id: string;
  status: ECampaignStatus;
  errors: string[];
  noOfCampaigns: number;
  createdBy: string;
  fileName: string;
}

export interface IBulkBundlePromotion {
  bulkBundleJobs?: IBulkBundleJob[];
  newBulkBundleJob?: IBulkBundleJob;
  bulkBundleJob?: IBulkBundleJob;
  page: number;
  total: number;
}

export const BULK_BUNDLE_PROMOTION_INITIAL_STATE = {
  page: 0,
  total: 0,
};

export default (
  state: IBulkBundlePromotion = BULK_BUNDLE_PROMOTION_INITIAL_STATE,
  action: IAction
) => {
  switch (action.type) {
    case ADD_BULK_BUNDLE_JOB_TO_THE_LIST:
      return {
        ...state,
        newBulkBundleJob: action.payload,
      };
    case BULK_BUNDLE_SET_JOBS: {
      const { campaigns } = action.payload;

      const newBulkBundleJob = state.newBulkBundleJob;
      let jobDashboardState = [...(state.bulkBundleJobs || []), ...campaigns];

      if (
        newBulkBundleJob &&
        !jobDashboardState.find((c) => c.id === newBulkBundleJob.id)
      ) {
        jobDashboardState = [newBulkBundleJob, ...jobDashboardState];
      }
      const total = jobDashboardState.length;
      return {
        ...state,
        bulkBundleJobs: jobDashboardState,
        newBulkBundleJob: null,
        total,
      };
    }
    case BULK_BUNDLE_UPDATE_JOB_STATUS: {
      const { id: idToUpdate, status: newStatus } = action.payload;
      const { bulkBundleJobs = [] } = state;
      const newBulkBundleJobs = bulkBundleJobs.map((job) =>
        job.id === idToUpdate ? { ...job, status: newStatus } : job
      );
      return {
        ...state,
        bulkBundleJobs: newBulkBundleJobs,
        bulkBundleJob: {
          ...state.bulkBundleJob,
          status: newStatus,
        },
      };
    }
    case BULK_BUNDLE_UPDATE_PAGE_NUMBER:
      return {
        ...state,
        page: action.payload,
      };
    case BULK_BUNDLE_CLEAR_JOB_LIST:
      return {
        ...state,
        bulkBundleJobs: [],
        page: 0,
        total: 0,
      };
    default:
      return state;
  }
};
